var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card-group',{attrs:{"deck":""}},[_c('b-card',{attrs:{"header":"Details","bg-variant":"light"}},[_c('b-table-lite',{attrs:{"borderless":"","small":"","stacked":"","fields":_vm.fields.middle,"items":_vm.tableData},scopedSlots:_vm._u([{key:"cell(phone)",fn:function(row){return [_vm._v(_vm._s(row.item.phone.formatted))]}}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }